import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import './Navbar.css';

const Navbar = () => {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    const toggleMobileMenu = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
    };
    
    return (
        <nav className="navbar">
            <div className="navbar-container">
                {/* Logo Section */}
                <div className="navbar-logo">
                    <NavLink to="/" className="logo-link">
                        <img src="/images/logo.png" alt="Akaina Logo" className="logo-image" />AKAINA
                    </NavLink>
                </div>
                
                {/* Hamburger Menu for Mobile */}
                <div className="hamburger" onClick={toggleMobileMenu}>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
                
                {/* Navigation Links */}
                <ul className={`navbar-links ${isMobileMenuOpen ? 'mobile active' : ''}`}>
                    <li>
                        <NavLink
                            to="/"
                            className={({ isActive }) =>
                                isActive ? "navbar-link active" : "navbar-link"
                            }
                            end
                        >
                            Home
                        </NavLink>
                    </li>
                    <li>
                        <NavLink
                            to="/tournament-results"
                            className={({ isActive }) =>
                                isActive ? "navbar-link active" : "navbar-link"
                            }
                        >
                            Tournament Results
                        </NavLink>
                    </li>
                    <li>
                        <NavLink
                            to="/metagame-breakdown"
                            className={({ isActive }) =>
                                isActive ? "navbar-link active" : "navbar-link"
                            }
                        >
                            Metagame Breakdown
                        </NavLink>
                    </li>
                </ul>
            </div>
        </nav>
    );
};

export default Navbar;